import { useGlobalStore } from "@/store/GlobalStore";
import { Zone } from "project-config/constants";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { createGlobalStyle } from "styled-components";

export function ChildCoupon({
  coupon,
  qyCoupon,
}: {
  coupon: string;
  qyCoupon: string;
}) {
  const { userInfo } = useGlobalStore();
  const t = getTranslateNsT("center");
  return (
    <div className="child-coupon">
      {Boolean(coupon) && (
        <p>
          <span>{`${t("recharge_coupon")}：`}</span>
          {`${userInfo?.zone === Zone.Domestic ? "￥" : "$"}${parseFloat(
            coupon
          ).toLocaleString()}`}
        </p>
      )}
      {Boolean(qyCoupon) && (
        <p>
          <span>{`${t("recharge_qyCoupon")}：`}</span>
          {`${userInfo?.zone === Zone.Domestic ? "￥" : "$"}${parseFloat(
            qyCoupon
          ).toLocaleString()}`}
        </p>
      )}
      <CouponTextStyle />
    </div>
  );
}

const CouponTextStyle = createGlobalStyle`
  .child-coupon {
    p {
      margin: unset;
      font-size: 14px;
      line-height: 22px;
    }
  }
`;
